import React, { useEffect, useRef, useState } from "react";
import { NavLink, useLocation } from "react-router-dom";
import { FaBars, FaTimes } from "react-icons/fa";
import { FiChevronDown } from "react-icons/fi";
import logo from "../asset/lumetra-softech-logo.png";

const menus = [
  {
    label: "Web Development",
    links: [
      ["Web Design & Development", "/web-development"],
      ["E-commerce Solution", "/ecommerce"],
      ["App Development", "/appdevelopment"],
      ["Web Application", "/webapplication"],
    ],
  },
  {
    label: "Digital Marketing",
    links: [
      ["Search Engine Optimization (SEO)", "/seo"],
      ["Social Media Marketing (SMM)", "/smm"],
    ],
  },
  {
    label: "Products",
    links: [
      ["School Management Application", "/school-management"],
      ["CRM Development", "/crm-development"],
      ["Invoicing Solution", "/invoicing-solution"],
      ["Hospital Management Software", "/hospital-management"],
    ],
  },
  {
    label: "Company",
    links: [
      ["About Us", "/about"],
      ["Mission & Values", "/mission-values"],
      ["Why Choose Us", "/choose-us"],
    ],
  },
];

const Navbar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);
  const navRef = useRef(null);
  const location = useLocation();

  useEffect(() => {
    setMobileOpen(false);
    setOpenMenu(null);
  }, [location.pathname]);

  useEffect(() => {
    const closeOnEscape = (event) => {
      if (event.key === "Escape") {
        setMobileOpen(false);
        setOpenMenu(null);
      }
    };
    const closeOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setMobileOpen(false);
        setOpenMenu(null);
      }
    };
    document.addEventListener("keydown", closeOnEscape);
    document.addEventListener("pointerdown", closeOutside);
    return () => {
      document.removeEventListener("keydown", closeOnEscape);
      document.removeEventListener("pointerdown", closeOutside);
    };
  }, []);

  const toggleMenu = (label) => {
    setOpenMenu((current) => (current === label ? null : label));
  };

  return (
    <header ref={navRef} className="sticky top-0 z-50 border-b border-slate-200 bg-white shadow-sm">
      <nav className="mx-auto flex min-h-[76px] max-w-7xl items-center justify-between px-5 lg:px-8" aria-label="Primary navigation">
        <NavLink to="/" className="shrink-0 rounded-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600" aria-label="Lumetra Softech home">
          <img className="h-12 w-auto object-contain sm:h-14" src={logo} alt="Lumetra Softech" />
        </NavLink>

        <button
          type="button"
          className="inline-flex h-11 w-11 items-center justify-center rounded-md text-slate-800 hover:bg-teal-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600 lg:hidden"
          onClick={() => {
            setMobileOpen((open) => !open);
            setOpenMenu(null);
          }}
          aria-expanded={mobileOpen}
          aria-controls="mobile-navigation"
          aria-label={mobileOpen ? "Close navigation menu" : "Open navigation menu"}
        >
          {mobileOpen ? <FaTimes aria-hidden="true" /> : <FaBars aria-hidden="true" />}
        </button>

        <ul className="hidden items-center gap-1 lg:flex">
          <li>
            <NavLink to="/" className={({ isActive }) => `nav-link ${isActive ? "nav-link-active" : ""}`} end>Home</NavLink>
          </li>
          {menus.map((menu) => (
            <li
              key={menu.label}
              className="relative"
              onMouseEnter={() => setOpenMenu(menu.label)}
              onMouseLeave={() => setOpenMenu(null)}
            >
              <button
                type="button"
                className="nav-link inline-flex items-center gap-1"
                onClick={() => toggleMenu(menu.label)}
                onFocus={() => setOpenMenu(menu.label)}
                aria-expanded={openMenu === menu.label}
                aria-haspopup="true"
              >
                {menu.label}<FiChevronDown className={`transition-transform ${openMenu === menu.label ? "rotate-180" : ""}`} aria-hidden="true" />
              </button>
              {openMenu === menu.label && (
                <ul className="absolute right-0 top-full min-w-[250px] overflow-hidden rounded-md border border-slate-200 bg-white py-2 shadow-xl" aria-label={`${menu.label} submenu`}>
                    {menu.links.map(([label, path]) => (
                      <li key={path}>
                        <NavLink to={path} className="block px-4 py-2.5 text-sm font-medium text-slate-700 hover:bg-teal-50 hover:text-teal-800 focus:bg-teal-50 focus:text-teal-800 focus:outline-none">{label}</NavLink>
                      </li>
                    ))}
                </ul>
              )}
            </li>
          ))}
        </ul>
      </nav>

      {mobileOpen && (
        <div id="mobile-navigation" className="max-h-[calc(100vh-76px)] overflow-y-auto border-t border-slate-200 bg-white px-5 pb-6 lg:hidden">
          <ul className="mx-auto max-w-7xl py-3">
            <li><NavLink to="/" className="mobile-nav-link" end>Home</NavLink></li>
            {menus.map((menu) => (
              <li key={menu.label} className="border-t border-slate-100">
                <button type="button" className="mobile-nav-link flex w-full items-center justify-between" onClick={() => toggleMenu(menu.label)} aria-expanded={openMenu === menu.label}>
                  {menu.label}<FiChevronDown className={`transition-transform ${openMenu === menu.label ? "rotate-180" : ""}`} aria-hidden="true" />
                </button>
                {openMenu === menu.label && (
                  <ul className="mb-2 border-l-2 border-teal-600 pl-3">
                    {menu.links.map(([label, path]) => (
                      <li key={path}><NavLink to={path} className="block rounded px-3 py-2.5 text-sm font-medium text-slate-700 hover:bg-teal-50 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-600">{label}</NavLink></li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
